import React from "react";
import { useCombinedStore } from "../store";
import * as AlfredoStyles from "../styles/components/SupplyRequest";

const LastOptions: React.FC = () => {
  return (
    <AlfredoStyles.LastOptionsContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>warehouse</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Compras</AlfredoStyles.Title>
      </AlfredoStyles.Card>
    </AlfredoStyles.LastOptionsContainer>
  );
};

export default LastOptions;
